/**
 * Whether the next batch of user summaries should be loaded.
 *
 * The People lists render the full directory up front and stream summaries in
 * top-to-bottom, so the next batch is fetched once the last visible row reaches
 * the frontier of already-loaded rows — not the very end of the list. Shared by
 * `UserList` (All Users) and `FlexListInfinite` (Dashboard) so the batching rule
 * lives in one place. (TT-5478)
 */
export function shouldLoadMoreSummaries({
  lastVisibleIndex,
  loadedCount,
  hasMore,
  isFetching,
}: {
  lastVisibleIndex: number;
  loadedCount: number;
  hasMore: boolean;
  isFetching: boolean;
}): boolean {
  return lastVisibleIndex >= loadedCount - 1 && hasMore && !isFetching;
}
